// Docs https://github.com/biati-digital/glightbox
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

const lightbox = GLightbox({
	//option
});

